/**
 * Loading spinner component
 * Reusable spinner with size variants
 */
import { cn } from '@/lib/utils';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

// Size variant classes for the spinner
const sizeClasses = {
  sm: 'h-5 w-5',   // 20px - For inline use
  md: 'h-8 w-8',   // 32px - Default size
  lg: 'h-12 w-12', // 48px - For full-page loading
};

export function LoadingSpinner({ size = 'md', className }: LoadingSpinnerProps) {
  return (
    <div
      className={cn(
        'animate-spin rounded-full border-b-2 border-primary',
        sizeClasses[size],
        className
      )}
      role="status"
      aria-label="Loading"
    />
  );
}

